import React from "react";
import { GridList, GridListTile, Button, Chip } from "@material-ui/core";
/**
 *
 * @param {string} fieldName
 * @param {string} fieldValue
 * @param {boolean} fieldErrorStatus
 * @param {string} fieldErrorMsg
 */

export const validateEmpty = (fieldName, fieldValue, fieldErrorStatus, fieldErrorMsg) => {
  const errors = {};
  if (!fieldValue || fieldValue.length === 0) {
    errors[fieldName] = fieldErrorMsg;
    errors[fieldErrorStatus] = true;
  } else {
    errors[fieldName] = "";
    errors[fieldErrorStatus] = false;
  }
  return errors;
};

export const CustomDisplay = props => {
  return (
    <div>
      <GridList
        cols={3}
        cellHeight={60}
        style={{ border: "2px solid #aeaeae", borderRadius: "12px" }}
      >
        {props.options
          .filter((option, id) => id < props.numberOfItems)
          .map(option => (
            <GridListTile
              key={option}
              cols={1}
              style={{ textAlign: "center", border: "1px solid #aeaeae" }}
            >
              <div style={{ lineHeight: "60px" }} onClick={() => props.onChange(option)}>
                <div style={{ verticalAlign: "middle", color: option===props.value?"blue":"black" }}>{option}</div>
              </div>
            </GridListTile>
          ))}
      </GridList>
      <br/>
      <Button variant="contained"> + More</Button>
    </div>
  );
};

export const CustomChips = (props) => {
  const  addElement = (arr,val) => {
    return [...arr,val];
  }
  const  removeElement = (arr,val) => {
    return arr.filter(author=> author!==val);
  }
  return(
    <div>
      {props.options.map(chip => props.value.indexOf(chip)!==-1?<Chip key={chip} label={chip} onClick={() => props.onChange(removeElement(props.value,chip))} style={{background:"#e2786a", margin:"2px"}} />:<Chip key={chip} label={chip} onClick={() => props.onChange(addElement(props.value,chip))} style={{ margin:"2px"}} />)}
    </div>
  )
}